'use client';

import React, { ReactNode, useEffect, useState } from 'react';

import cn from '@/helpers/utils/classNames';

type ContainerProps = {
  children: ReactNode;
  className?: string;
};
const Container = ({ children, className }: ContainerProps) => {
  const [isBackofficeRoute, setIsBackofficeRoute] = useState(false);
  useEffect(() => {
    const isInsideBackofficeLayout = !!document.querySelector('[data-backoffice]');
    setIsBackofficeRoute(isInsideBackofficeLayout);
  }, []);
  if (typeof window !== 'undefined' && isBackofficeRoute === null) return null;
  return (
    <div
      className={cn(
        isBackofficeRoute
          ? // ? 'v2-px-[80px] 2xl:v2-px-[80px] xl:v2-px-[32px] lg:v2-px-[165px] md:v2-px-[32px] sm:v2-px-[16px] xs:v2-px-[16px] main-dashboard-container'
            'main-dashboard-container'
          : // ? 'xl:v2-px-[80px] lg:v2-px-[80px] md:v2-px-10 sm:v2-px-4 xs:v2-px-4 main-dashboard-container'
            'xl:v2-max-w-[1080px] lg:v2-max-w-[1080px] md:v2-max-w-[1080px] md:v2-px-[32px] sm:v2-px-[16px] sm:v2-w-full xs:v2-px-[16px] xs:v2-w-full lg:v2-px-0 md:v2-w-full xl:v2-mx-auto lg:v2-mx-auto md:v2-mx-auto',
        className
      )}
    >
      {children}
    </div>
  );
};
export default Container;
